module.exports = __webpack_public_path__ + "static/media/SSN.5d5342c0.png";